import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { ReferenceImageDeleteList } from './reference-image-delete-list.model';

export class ImageInstructListRowModel {

  public imageID: string = <string>'';
  public imageBelongIDName: string = <string>'';
  public imageName: string = <string>'';
  public imageFileName: string = <string>'';
  public status: string = <string>'';
  public statusName: string = <string>'';
  public imageType: string = <string>'';
  public imageTypeName: string = <string>'';
  public processInstruct: string = <string>'';
  public processInstructName: string = <string>'';
  public cookingExPublish: string = <string>'';
  public cookingDiv: string = <string>'';
  public cookingName: string = <string>'';
  public materialName: string = <string>'';
  public eventID: string = <string>'';
  public photoContentsDiv: string = <string>'';
  public remarks: string = <string>'';
  public keyWord: string = <string>'';
  public textCaption: string = <string>'';
  public photoInstructContents: string = <string>'';
  public editStatus: string = <string>'';
  public colorChange: string = <string>'';
  public multipleCode: string = <string>'';	// 複数コード
  public sampleNum: string = <string>'';	// サンプル数量
  public promotionFlg: boolean = <boolean>false;	// プロモーション
  public shooting: string = <string>'';	// 包材_撮影
  public shootingPackageText: string = <string>'';	// 包材_撮影／外包材と個包装
  public shootingAngle: string = <string>'';	// 包材_撮影角度
  public alignment: string = <string>'';	// 包材_並べ方
  public alignmentHorizontal: string = <string>'';	// 包材_並べ方／横
  public alignmentVertical: string = <string>'';	// 包材_並べ方／縦
  public vesselPlating: string = <string>'';	// 皿盛・ザル盛_器
  public plating: string = <string>'';	// 皿盛・ザル盛_盛り方
  public accompaniments: string = <string>'';	// 皿盛・ザル盛_添え物
  public qtyCookNecessary: string = <string>'';	// 調理要_数量
  public qtyCookNecessaryNum: string = <string>'';	// 調理要_数量／個数
  public qtyCookNecessaryVesselNum: string = <string>'';	// 調理要_数量／器数
  public vesselShapeCookNecessary: string = <string>'';	// 調理要_器形状
  public vesselCookNecessary: string = <string>'';	// 調理要_器
  public photoImageCookNecessary: string = <string>'';	// 調理要_イメージ
  public crossSection: boolean = <boolean>false;	// 断面
  public photoRenditionCookNecessary: string = <string>'';	// 調理要_撮影演出
  public qtyCookUnnecessary: string = <string>'';	// 調理不要_数量
  public qtyCookUnnecessaryNum: string = <string>'';	// 調理不要_数量／個数
  public qtyCookUnnecessaryVesselNum: string = <string>'';	// 調理不要_数量／器数
  public vesselShapeCookUnnecessary: string = <string>'';	// 調理不要_器形状
  public vesselCookUnnecessary: string = <string>'';	// 調理不要_器
  public photoImageCookUnnecessary: string = <string>'';	// 調理不要_イメージ
  public photoRenditionCookUnnecessary: boolean = <boolean>false;	// 調理不要_撮影演出
  public cropExistenceType: string = <string>'';	// 切抜or角版
  public referenceImageFileName1: string = <string>'';  // 参照資料ファイル名1
  public photoInstructContents1: string = <string>'';   // 撮影指示内容1
  public imageSrc1: string = <string>'';   // 画像1
  public registeredImageFileFlg1: boolean = <boolean>false;	// 参照資料ファイル名1登録済みフラグ
  public referenceImageFileName2: string = <string>'';  // 参照資料ファイル名2
  public photoInstructContents2: string = <string>'';   // 撮影指示内容2
  public imageSrc2: string = <string>'';   // 画像2
  public registeredImageFileFlg2: boolean = <boolean>false;	// 参照資料ファイル名2登録済みフラグ
  public referenceImageFileName3: string = <string>'';  // 参照資料ファイル名3
  public photoInstructContents3: string = <string>'';   // 撮影指示内容3
  public imageSrc3: string = <string>'';   // 画像3
  public registeredImageFileFlg3: boolean = <boolean>false;	// 参照資料ファイル名3登録済みフラグ

  /**
   * サーバから取得したデータを当クラスに詰めなおす
   *
   * @static
   * @param {*} serverData サーバから取得したデータ
   * @returns {Array<ImageInstructListRowModel>}
   * @memberof ImageInstructListRowModel
   */
  public static create(serverData: any): Array<ImageInstructListRowModel> {
    const returnArray = new Array<ImageInstructListRowModel>();
    serverData.forEach(data => {
      const m = new ImageInstructListRowModel();
      m.imageID = data.ImageID;
      m.imageBelongIDName = data.ImageBelongIDName;
      m.imageName = data.ImageName;
      m.imageFileName = data.ImageFileName;
      m.status = data.Status;
      m.statusName = data.StatusName;
      m.imageType = data.ImageType;
      m.imageTypeName = data.ImageTypeName;
      m.processInstruct = data.ProcessInstruct;
      m.processInstructName = data.ProcessInstructName;
      m.cookingExPublish = data.CookingExPublish;
      m.cookingDiv = data.CookingDiv;
      m.cookingName = data.CookingName;
      m.materialName = data.MaterialName;
      m.eventID = data.EventID;
      m.photoContentsDiv = data.PhotoContentsDiv;
      m.remarks = data.Remarks;
      m.keyWord = data.KeyWord;
      m.textCaption = data.TextCaption;
      m.photoInstructContents = data.PhotoInstructContents;
      m.multipleCode = data.MultipleCode;
      m.sampleNum = data.SampleNum;
      m.promotionFlg = data.PromotionFlg === '1' ? true : false;
      m.shooting = data.Shooting;
      m.shootingPackageText = data.ShootingPackageText;
      m.shootingAngle = data.ShootingAngle;
      m.alignment = data.Alignment;
      m.alignmentHorizontal = data.AlignmentHorizontal;
      m.alignmentVertical = data.AlignmentVertical;
      m.vesselPlating = data.VesselPlating;
      m.colorChange = data.ColorChange;
      m.plating = data.Plating;
      m.accompaniments = data.Accompaniments;
      m.qtyCookNecessary = data.QtyCookNecessary;
      m.qtyCookNecessaryNum = data.QtyCookNecessaryNum;
      m.qtyCookNecessaryVesselNum = data.QtyCookNecessaryVesselNum;
      m.vesselShapeCookNecessary = data.VesselShapeCookNecessary;
      m.vesselCookNecessary = data.VesselCookNecessary;
      m.photoImageCookNecessary = data.PhotoImageCookNecessary;
      m.crossSection = data.CrossSection === '01' ? true : false;
      m.photoRenditionCookNecessary = data.PhotoRenditionCookNecessary;
      m.qtyCookUnnecessary = data.QtyCookUnnecessary;
      m.qtyCookUnnecessaryNum = data.QtyCookUnnecessaryNum;
      m.qtyCookUnnecessaryVesselNum = data.QtyCookUnnecessaryVesselNum;
      m.vesselShapeCookUnnecessary = data.VesselShapeCookUnnecessary;
      m.vesselCookUnnecessary = data.VesselCookUnnecessary;
      m.photoImageCookUnnecessary = data.PhotoImageCookUnnecessary;
      m.photoRenditionCookUnnecessary = data.PhotoRenditionCookUnnecessary === '1' ? true : false;
      m.cropExistenceType = data.CropExistenceType;
      m.referenceImageFileName1 = data.ReferenceImageFileName1;
      m.photoInstructContents1 = data.PhotoInstructContents1;
      m.imageSrc1 = data.ImagePreviewUrl1;
      m.registeredImageFileFlg1 = !PlessViewUtilsSub.isEmpty(m.referenceImageFileName1) ? true : false;
      m.referenceImageFileName2 = data.ReferenceImageFileName2;
      m.photoInstructContents2 = data.PhotoInstructContents2;
      m.imageSrc2 = data.ImagePreviewUrl2;
      m.registeredImageFileFlg2 = !PlessViewUtilsSub.isEmpty(m.referenceImageFileName2) ? true : false;
      m.referenceImageFileName3 = data.ReferenceImageFileName3;
      m.photoInstructContents3 = data.PhotoInstructContents3;
      m.imageSrc3 = data.ImagePreviewUrl3;
      m.registeredImageFileFlg3 = !PlessViewUtilsSub.isEmpty(m.referenceImageFileName3) ? true : false;

      returnArray.push(m);
    });
    return returnArray;
  }

}
